import React from "react"
import {GameMode,
  Index,
  List,
  ListItem,
  Rule,
  RulesListContainer} from "./styled"
import { skin } from "../../../styles/skin"

const RulesList = ({
  className,
  gameMode,
  rules,
  fontColor,
  bgColor,
  hasEvenlyRoundedCorners,
  fonts
}) => (
  <RulesListContainer
    bgColor={bgColor}
    className={className}
    fontColor={fontColor}
    fontName={fonts.secondaryFont}
    hasEvenlyRoundedCorners={hasEvenlyRoundedCorners}
  >
    <GameMode>
      { gameMode.toUpperCase() }
    </GameMode>
    <List>
      {
        rules.map((rule, i) => (
          <ListItem key={rule}>
            <Index>
              { `${i + 1}. ` }
            </Index>
            <Rule>
              { rule }
            </Rule>
          </ListItem>
        ))
      }
    </List>
  </RulesListContainer>
)

RulesList.defaultProps = {
  bgColor: "#ffffff",
  fontColor: "#0F1635",
  gameMode: "Punkte",
  rules: [
    "Richtige Antworten geben Punkte, falsche kosten Punkte.",
    "Je schneller du antwortest, desto mehr Punkte gewinnst oder verlierst du.",
    "Wenn du nicht antwortest, bleibt deine Punktzahl unverändert, spiel also strategisch!",
    "Der Spieler mit den meisten Punkten am Ende gewinnt.",
  ],
}

export default RulesList
